import './CardActions.a76cff67eae0ab743ef29ee1c5847504.css';
export default {"cardActions":"_cardActions_pu63g_1"};